<script>
    import { CardText } from 'sveltestrap';


import CardsInscricao from './CardsInscricao.svelte';

export let cards = []; // Lista de objetos com dados dos cards
export let navegarPara="";

</script>

<style>
    .grid-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 3em;
    }

    @media (min-width: 600px) {
        .grid-container {
            justify-content: flex-start;
        }
    }

    @media (min-width: 900px) {
        .grid-container {
            justify-content: flex-start;
        }
    }
</style>

<div class="grid-container">
    {#each cards as card}
        <CardsInscricao 
            imageUrl={card.imageUrl} 
            navegarPara={card.navegarPara+"?id="+card.id} 
            id={card.id} 
            textinho={card.textinho}
            titulo = {card.titulo}
            texto_botao={card.texto_botao}
            descricao={card.descricao}
          
            botao_habilitado={card.botao_habilitado}

            
            />
    {/each}
</div>
